<template name="privacyModal">
  <transition name="fade">
    <div class="privacy-modal" v-show="privacyContentShow">
      <div class="close-modal">
        <h2>{{$t('PrivacyPolicy')}}</h2>
        <div class="close-icon" @click="emitClosePrivacy">
        <img src="../assets/images/close-pop.png" alt="">
        </div>
      </div>
      <div class="privacy-content" v-html="privacyContent">
      </div>
    </div>
  </transition>
</template>

<script type="text/javascript">
export default {
  name: 'privacyModal',
  props: {
    privacyContent: String,
    privacyContentShow: Boolean,
  },
  watch: {
    privacyContentShow(currentVal) {
      const bodyEle = document.querySelector('body');
      if (currentVal) {
        bodyEle.classList.add('modal-open');
      } else {
        bodyEle.classList.remove('modal-open');
      }
    },
  },
  data() {
    return {
      showComfirmDelete: true,
    };
  },
  methods: {
    emitClosePrivacy() {
      this.$emit('closePrivacy');
    }
  },
};
</script>

<style lang="scss">
  .privacy-modal {
    left: 0;
    top: 50px;
    bottom: 0;
    right: 0;
    background: #fff;
    height: 100%;
    z-index: 2000;
    position: fixed;
    padding: 30px;
    overflow: auto;
    color: #4a4a4a;
    box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.07);
    .close-modal {
      display: flex;
      max-width: 600px;
      margin: auto;
      .close-icon {
        width: 12px;
        line-height: 12px;
        img {
          max-width: 100%;
        }
      }
      h2 {
        font-size: 17px;
        font-weight: bold;
        text-align: center;
        flex: 1;
      }
    }
    .privacy-content {
      max-width: 600px;
      margin: auto;
      p {
        font-size: 13px;
      }
    }
  }
</style>
